import type { SliceStateFromReducer } from 'shared/types';

import type { TScenarioState } from 'entities/scenario/model/scenario.selectors';
import type { creditTimerSlice } from 'entities/scenario/model/timer/creditTimer.slice';

export type TCreditTimerState = SliceStateFromReducer<typeof creditTimerSlice>;

export const getRemainingSeconds = (state: TCreditTimerState & TScenarioState) => {
  const currentStep = state.scenario.currentStep?.step;

  return currentStep ? (state.creditTimer.timers[currentStep]?.remaining ?? 0) : 0;
};
